module.exports = __webpack_public_path__ + "img/pin.b761b5ae.svg";